export { PLUGIN_KEY, PLUGIN_PRIORITY, HiddenColumns } from "./hiddenColumns.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/hiddenColumns/index.mjs
// module id = 1436
// module chunks = 1